import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";
import { useAuth } from "@/auth/AuthContext";

// #292 (UC-2): Verantwortlichen setzen/entziehen — Marketplace + Workspace-Vorlage.
// `ownerId: null` = entziehen (→ System, alle Admins). Admin-only (Server erzwingt).

function useClient() {
  const { session, logout } = useAuth();
  return () =>
    createApiClient({
      getToken: () => session?.accessToken ?? null,
      onUnauthorized: logout,
    });
}

export function useSetMarketplaceOwner() {
  const qc = useQueryClient();
  const client = useClient();
  return useMutation({
    mutationFn: ({ id, ownerId }: { id: string; ownerId: string | null }) =>
      client().put<{ ownerId: string | null }>(`/marketplaces/${encodeURIComponent(id)}/owner`, { ownerId }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.resource("marketplaces") });
      // Plugin-Details ERBEN den Marketplace-Owner → deren Cache mit auffrischen.
      void qc.invalidateQueries({ queryKey: queryKeys.resource("plugins") });
    },
  });
}

export function useSetTemplateOwner() {
  const qc = useQueryClient();
  const client = useClient();
  return useMutation({
    mutationFn: ({ id, ownerId }: { id: string; ownerId: string | null }) =>
      client().put<{ ownerId: string | null }>(`/workspace-templates/${encodeURIComponent(id)}/owner`, { ownerId }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["resources", "workspace-templates"] });
    },
  });
}
